export default [
  {
    path: '/author-tasks',
    name: 'author-tasks',
    component: () => import('@/views/author-tasks/AuthorTasksList.vue'),
    meta: {
      pageTitle: 'Задачи авторов',
      breadcrumb: [
        { text: 'Задачи авторов', active: true },
      ],
      resource: 'author-tasks',
      action: 'view',
    },
  },
]
